export class Http {
    constructor(){
        this.busy
    }
    /**
     * Requests a representation of the specified resource, should only retrieve data.
     * @param {*} url 
     * @param {*} data 
     * @param {*} callback 
     * @param {*} errorCallback 
     * @param {*} completeCallback 
     * @param {*} progressCallback 
     */
     get(url,callback,errorCallback,completeCallback,progressCallback) {
       
        this.request('GET',url,null,callback,errorCallback,completeCallback,progressCallback)
    }
    /**
     * Asks for a response identical to a GET request, but without the response body
     * @param {*} url 
     * @param {*} data 
     * @param {*} callback 
     * @param {*} errorCallback 
     * @param {*} completeCallback 
     * @param {*} progressCallback 
     */
    head(url,data,callback,errorCallback,completeCallback,progressCallback) {
        this.request('HEAD',url,data,callback,errorCallback,completeCallback,progressCallback)
    }
    /**
     * Submits an entity to the specified resource, often causing a change in state or side effects on the server
     * @param {*} url 
     * @param {*} data 
     * @param {*} callback 
     * @param {*} errorCallback 
     * @param {*} completeCallback 
     * @param {*} progressCallback 
     */
    post(url,data,callback,errorCallback,completeCallback,progressCallback) {
        
        this.request('POST',url,data,callback,errorCallback,completeCallback,progressCallback)
    }
    /**
     * Replaces all current representations of the target resource with the request payload.
     * @param {*} url 
     * @param {*} data 
     * @param {*} callback 
     * @param {*} errorCallback 
     * @param {*} completeCallback 
     * @param {*} progressCallback 
     */
    put(url,data,callback,errorCallback,completeCallback,progressCallback) {
        this.request('PUT',url,data,callback,errorCallback,completeCallback,progressCallback)
    }
    /**
     * Deletes the specified resource
     * @param {*} url 
     * @param {*} data 
     * @param {*} callback 
     * @param {*} errorCallback 
     * @param {*} completeCallback 
     * @param {*} progressCallback 
     */
    delete(url,data,callback,errorCallback,completeCallback,progressCallback) {

        if(data){
            if(typeof data === 'function'){
                if(typeof data() === 'object'){
                    data = data()
                }else{
                    callback = data
                    data = []
                }
            }      
        }
        this.request('DELETE',url,data,callback,errorCallback,completeCallback,progressCallback)
    }
    /**
     * Establishes a tunnel to the server identified by the target resource
     * @param {*} url 
     * @param {*} data 
     * @param {*} callback 
     * @param {*} errorCallback 
     * @param {*} completeCallback 
     * @param {*} progressCallback 
     */
    connect(url,data,callback,errorCallback,completeCallback,progressCallback) {
        this.request('CONNECT',url,data,callback,errorCallback,completeCallback,progressCallback)
    }
    /**
     * Describes the communication options for the target resource
     * @param {*} url 
     * @param {*} data 
     * @param {*} callback 
     * @param {*} errorCallback 
     * @param {*} completeCallback 
     * @param {*} progressCallback 
     */
    options(url,data,callback,errorCallback,completeCallback,progressCallback) {
        this.request('OPTIONS',url,data,callback,errorCallback,completeCallback,progressCallback)
    }
    /**
     * Performs a message loop-back test along the path to the target resource
     * @param {*} url 
     * @param {*} data 
     * @param {*} callback 
     * @param {*} errorCallback 
     * @param {*} completeCallback 
     * @param {*} progressCallback 
     */
    trace(url,data,callback,errorCallback,completeCallback,progressCallback) {
        this.request('TRACE',url,data,callback,errorCallback,completeCallback,progressCallback)
    }
    /**
     * Applies partial modifications to a resource
     * @param {*} url 
     * @param {*} data 
     * @param {*} callback 
     * @param {*} errorCallback 
     * @param {*} completeCallback 
     * @param {*} progressCallback 
     */
    patch(url,data,callback,errorCallback,completeCallback,progressCallback) {
        this.request('PATCH',url,data,callback,errorCallback,completeCallback,progressCallback)
    }
    /**
     * Fetch request with given method, url, data, and callback
     * @param {*} method GET, HEAD, POST, PUT, DELETE, CONNECT, OPTIONS, TRACE, PATCH
     * @param {*} url Request url
     * @param {*} data Body data
     * @param {*} callback Callback function
     * @param {*} errorCallback Error callback function
     * @param {*} completeCallback Complete callback function
     * @param {*} progressCallback Progress callback function
     */
    request(method,url,data = {},callback,errorCallback,completeCallback,progressCallback) {
        if(this.busy) return // only perform request if not busy
        const options = {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': ui.token // Gets the CSRF token from the UI class
            }
        },requestUrl = url.startsWith('/') || url.startsWith('http')? url : '/' + url

        if(method === 'POST' || method === 'PUT' || method === 'PATCH' || method === 'DELETE'){
            if (data) 
                data = { _method : method.toLowerCase(), ...data }
            else 
                data = { _method : method.toLowerCase() }
            options.method = 'POST'
            options.body = JSON.stringify(data)
        }

        fetch(requestUrl,options).then(response => {

            this.busy = true

            if(options.log)
                console.log(requestUrl, response)
            if(response.ok){
                this.busy = false // permit next request to be executed
                return response.text()
            }else{
                ui.modal({
                    title: 'Error',
                    body: 'Error: ' + response.status + ' ' + response.statusText,
                })
            }
            throw new Error(response.statusText)
        }).then(data => {
            if(str.isJson(data))
                data = JSON.parse(data)
            if(str.isHTML(data))
                data = DOM.parser(data)
            if(typeof callback === 'function')
                return callback(data)
            return data
               
        }).catch(error => {
            if(errorCallback)
                errorCallback(error)
        }).finally(() => {
            if(completeCallback)
                completeCallback()
        }).onprogress = (event) => {
            if(progressCallback)
                progressCallback(event)
        }
    }
    /**
     * 
     * @param {*} options 
     */
    upload(options = {
        form : ui.select('form[enctype="multipart/form-data"]'),
        input : ui.select('input[type="file"]')
    }){
        const formData = new FormData(),
              request = new XMLHttpRequest(),
              progressBar = ui.element('div', { class : 'progress-bar', role : 'progressbar', 'aria-valuenow' : 0, 'aria-valuemin' : 0, 'aria-valuemax' : 100 }),
              progress = ui.element('div',{ class : 'progress'}, progressBar)
        options.target.parentElement.append(progress)
        request.upload.addEventListener( 'progress', event => {
            const fileSize = file_input.files[0].size
            if(event.loaded <= fileSize){
                const  percent = Math.round(event.loaded / fileSize * 100 )
                progressBar.style.width = `${percent}%`
                progressBar.setAttribute('aria-valuenow', percent)
                progressBar.textContent = `${percent}%`
            }
            if(event.loaded === event.total){
                progressBar.style.width = '100%'
                progressBar.setAttribute('aria-valuenow', 100)
                progressBar.textContent = '100%'
            }
        })
        request.open('post', options.form.action)
        request.send(formData)
    }
}